import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { defaultContainerSize, mq } from '../../../styles/mixins';
import { THEME } from '../../../common/consts/theme';
import { rgba } from 'emotion-rgba';

export const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.core_black};
  min-height: 6rem;

  ${mq.xSmall(css`
    min-height: 9.25rem;
  `)};

  ${mq.medium(css`
    min-height: 14rem;
  `)};

  ${mq.xLarge(css`
    min-height: 22.5rem;
  `)};
`;

export const Inner = styled.div`
  ${defaultContainerSize};
  height: 100%;
  display: flex;
  min-height: inherit;
  justify-content: flex-start;
  align-items: flex-end;
`;

export const HeroBlock = styled.hr`
  position: absolute;
  width: 100vw;
  bottom: 0;
  left: 0;
  margin: 0;
  border: none;
  background-color: ${({ theme }) => theme.colors.core_black};
  height: 0.5rem;

  ${mq.xSmall(css`
    height: 1rem;
  `)};

  ${mq.medium(css`
    height: 1.25rem;
    bottom: -2px;
  `)};

  ${mq.xLarge(css`
    height: 1.875rem;
    bottom: 0;
  `)};
`;

export const Title = styled.h1`
  font-size: 3.25rem;
  line-height: 4rem;
  font-weight: 400;
  letter-spacing: 0.0375rem;
  background: linear-gradient(90deg, #584ca9 0%, #be4969 100%);
  background-clip: text;
  font-family: ${({ theme }) => theme.font.questrial};
  color: ${rgba(THEME.colors.core_white, 0)};
  position: relative;
  user-select: none;
  margin: 0 0 -0.6875rem 0;

  ${mq.xSmall(css`
    font-size: 4.25rem;
    line-height: 5.125rem;
  `)};

  ${mq.medium(css`
    font-size: 8rem;
    line-height: 9.25rem;
    margin-bottom: -1.6875rem;
  `)};

  ${mq.xLarge(css`
    font-size: 13rem;
    line-height: 15.125rem;
    margin-bottom: -2.75rem;
  `)};
`;
